import { service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router';
import type SessionContextService from '../services/session-context';
import type SessionService from '../services/session';
import pageTitle from 'ember-page-title/helpers/page-title';
import { t } from 'ember-intl';
import { NotificationsContainer } from 'tio-reimagined/components/notifications';
import DemoDataShortcut from 'tio-employee/components/demo-data-shortcut';
import ENV from 'tio-employee/config/environment';

export default class ApplicationRouteComponent extends Component {
  @service declare router: RouterService;
  @service declare session: SessionService;
  @service declare sessionContext: SessionContextService;

  get isFullyAuthenticatedPage() {
    return this.sessionContext.isFullyAuthenticated;
  }

  get isDemoDataShortcutEnabled() {
    if (ENV.tioEnvironment !== 'production') {
      return true;
    }

    if (typeof window === 'undefined') {
      return false;
    }

    const params = new URLSearchParams(window.location.search);
    return params.get('demo') === 'true' || localStorage.getItem('reimagined-demo-mode') === 'true';
  }

  <template>
    {{pageTitle (t "application_page_title")}}

    {{outlet}}

    <NotificationsContainer />
    {{#if this.isDemoDataShortcutEnabled}}
      <DemoDataShortcut />
    {{/if}}

    {{! Global portal target for Drawers and overlays to avoid parent portal nesting issues }}
    <div id="tio-drawer-target"></div>
  </template>
}
